export default __webpack_public_path__ + "static/media/onenote-icon.a7bbc759.svg";